import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const SuluAdminRoleIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path
                d="M2 8.93182L5.10345 17.1136L17.5172 19.5M2 8.93182L15.7931 4.5M2 8.93182L11.3103 10.6364M15.7931 4.5L11.3103 10.6364M15.7931 4.5L16.3025 8.93182M17.5172 19.5L11.3103 10.6364M17.5172 19.5L22 12.3409L16.3025 8.93182M17.5172 19.5L16.3025 8.93182"
                fill="none"
                stroke={props.htmlColor || '#21272E'}
                strokeWidth="1.5"
            />
        </SvgIcon>
    );
};
